import axiosConfig from "./axiosConfig";

const deleteOrganisation = async (
  authToken: string,
  orgId: string
): Promise<void> => {
  const { data } = await axiosConfig.delete(`/organisation/${orgId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default deleteOrganisation;
